import { Modal, Stack } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import type { QuestionnaireResponse } from '@medplum/fhirtypes'
import * as questionnaires from '@seen/core/models/questionnaires/index'
import type { ExtendedTask } from '@seen/core/models/tasks/task'
import { Button } from '@seen/ui'
import type { JSX } from 'react'
import { CustomQuestionnaireForm } from '#src/components/questionnaire-form/CustomQuestionnaireForm.tsx'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'
import { usePatchMutation } from '#src/hooks/usePatchMutation.ts'

export function EditTaskDueDate({
  task,
}: {
  task: ExtendedTask<any>
}): JSX.Element {
  const isReadOnly = useIsReadOnly()
  const patch = usePatchMutation<ExtendedTask<any>>()
  const [opened, { toggle, close }] = useDisclosure(false)

  const handleChangeDueDate = async (dueDate: string): Promise<void> => {
    patch.mutate({
      instance: task,
      mutateFn: (task) => {
        task.dueOn = dueDate
      },
    })
  }

  const onQuestionnaireSubmit = async (
    formData: QuestionnaireResponse
  ): Promise<void> => {
    const dueDateAnswer =
      questionnaires.extractTypedAnswersFromQuestionnaireResponse(
        formData,
        questionnaires.editTaskDueDateQuestionnaire
      )

    if (dueDateAnswer.answers.dueDate) {
      const dueDate = dueDateAnswer.answers.dueDate
      await handleChangeDueDate(dueDate)
      close()
    }
  }

  return (
    <div>
      <Button className="w-full" onClick={toggle} disabled={isReadOnly}>
        Change Due Date
      </Button>
      <Modal opened={opened} onClose={close}>
        <Stack>
          <CustomQuestionnaireForm
            questionnaire={questionnaires.editTaskDueDateQuestionnaire}
            onSubmit={onQuestionnaireSubmit}
          />
        </Stack>
      </Modal>
    </div>
  )
}
